<template>
  <button
      v-if="!readOnly"
      @click="generateInputByAi"
      class="ml-1 mr-1 btn btn-plm-action"
      :disabled="loading || readOnly"
      :data-test-path="fieldConfig.fieldName"
  >
    <font-awesome-icon
        v-if="!loading"
        icon="fa-duotone fa-wand-magic-sparkles"/>
    <font-awesome-icon
        :icon="['fad', 'spinner-third']"
        v-else
        spin
        style="--fa-primary-color: #ffffff; --fa-secondary-color: #ffffff"
    />
  </button>
</template>
<script>

import FormValidatedField from "@/components/forms/FormValidatedField";
import ProductInSeason from "@/server/com/silkplm/model/plm/ProductInSeason";
import Inspiration from "@/server/com/silkplm/model/plm/Inspiration";
import Rpc from "@/Rpc";
import TextFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/TextFormFieldConfig";
import FormModel from "@/components/forms/FormModel";

export default {
  name: "FillFieldByAiButton",

  props: {
    validatedField: {type: FormValidatedField, required: false},
    fieldConfig: {type: TextFormFieldConfig, required: false},
    mode: {default: null},
    parentForm: {type: FormModel},
    readOnly: {type: Boolean, default: true},
    hexColor: {type: String, default: ''}
  },

  methods: {
    setReadOnly(readOnly) {
      this.readOnly = this.fieldConfig.readOnly || readOnly;
    },

    async translate(input) {
      return await Rpc.ai.GenerateDescriptionByAI.translateToOrganizationLanguage(SessionManager.defaultCustomerLanguageCode, input);
    },

    async generateInputByAi() {
      this.loading = true;
      this.$emit("loading", this.loading);
      let formValidatedField = this.parentForm.validatedFieldByName('productInSeasonId');
      let entityId;
      let image = [];
      if (this.mode === 'NEW' && this.parentForm.fields.image.value) {
        image.push(this.parentForm.fields.image.value);
      } else if (this.mode === 'EDIT') {
        if (formValidatedField) {
          entityId = formValidatedField.value;
          let productInSeason = new ProductInSeason();
          await productInSeason.load(entityId);
          image = productInSeason.gallery.imagesList.filter(element =>
              element.customData && element.customData?.imageTagList && element.customData?.imageTagList.some(x => x.name === "Main Picture")
          );
        }
        if (!entityId) {
          entityId = this.parentForm.validatedFieldByName('id').value;
          let inspiration = new Inspiration();
          await inspiration.load(entityId);
          image.push(inspiration.image);
        }
      } else {
        await DialogManager.info($tr('fill-inputs-renderer-upload-photo', 'Empty Photo', 'You Have to Upload Photo.'));
      }

      let promise = true;
      let value = this.validatedField.validatedForm.validatedFieldByName(this.fieldConfig.fieldName).value;
      if (value) {
        promise = await DialogManager.yesNo($tr('imageViewer.generateDescOverride', 'Overriding Inputs'),
            $tr('image-viewer-desc-override', 'Are you sure that you want to override inputs?'));
      }
      if (image && image.length > 0 && promise) {
        this.descriptionAI = await Rpc.ai.GenerateDescriptionByAI.getImageDescriptionByAi(SessionManager.defaultCustomerLanguageCode, "", image[0], false);
        let variables = {};
        if (this.descriptionAI[this.fieldConfig.fieldName] instanceof Object) {
          for (let key in this.descriptionAI[this.fieldConfig.fieldName]) {
            if (this.descriptionAI[this.fieldConfig.fieldName].hasOwnProperty(key)) {
              variables[key] = this.descriptionAI[this.fieldConfig.fieldName][key];
            }
          }
          if (Object.keys(variables).length > 1 && this.fieldConfig.fieldName === 'color') {
            let valueOfColor = this.validatedField.validatedForm.validatedFieldByName(this.fieldConfig.fieldName).value;
            const {r, g, b, color_name} = this.descriptionAI[this.fieldConfig.fieldName];
            const pantone = await Rpc.Pantone.pantoneByRGBInFamily(r, g, b, "Cotton");
            if (pantone == null) {
              valueOfColor = `${valueOfColor.charAt(0).toUpperCase() + valueOfColor.slice(1)} (R: ${r}, G: ${g}, B: ${b})`;
            }
            this.validatedField.validatedForm.validatedFieldByName(this.fieldConfig.fieldName).value = color_name + ', ' + pantone.pantone;
          } else if (Object.keys(variables).length > 1) {
            this.validatedField.validatedForm.validatedFieldByName(this.fieldConfig.fieldName).value = Object.values(variables)[0];
          } else {
            this.validatedField.validatedForm.validatedFieldByName(this.fieldConfig.fieldName).value = await this.translate('Nothing Found');
          }
        } else if (this.descriptionAI[this.fieldConfig.fieldName]) {
          this.validatedField.validatedForm.validatedFieldByName(this.fieldConfig.fieldName).value = this.descriptionAI[this.fieldConfig.fieldName];
        } else {
          this.validatedField.validatedForm.validatedFieldByName(this.fieldConfig.fieldName).value = await this.translate('Nothing Found');
        }
      } else {
        this.validatedField.validatedForm.validatedFieldByName(this.fieldConfig.fieldName).value = await this.translate('No Main Picture Found');
      }
      this.loading = false;
      this.$emit("loading", this.loading);
    }
  },

  data: () => ({
    descriptionAI: '',
    loading: false
  })
}
</script>
